import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ArrowRightIcon } from "lucide-react";
import { CHECKOUT_URL } from "../data/content";
export function FloatingCta() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => {
      const el = document.getElementById("hero-cta");
      if (!el) return;
      setVisible(el.getBoundingClientRect().bottom < 0);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, {
      passive: true
    });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  return <AnimatePresence data-id="element-32" data-mp="gokqh4xsdqkk">
      {visible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="pointer-events-none fixed inset-x-0 bottom-0 z-40 px-3 pb-3 sm:pb-5" data-id="element-33" data-mp="gnj629uvrrq6">
          <div className="pointer-events-auto mx-auto max-w-md" data-id="element-34" data-mp="2b2p9m3rgc8gx">
            <a href={CHECKOUT_URL} className="cta-shake flex w-full items-center justify-center gap-2 rounded-2xl border-2 border-white bg-cta px-5 py-4 font-display text-lg font-extrabold uppercase tracking-wide text-white shadow-[0_12px_30px_-6px_rgba(10,26,51,0.5)] transition-colors duration-150 hover:bg-ctaDark focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-cta/40" data-id="element-35" data-mp="2b38ofblt2gqq">
              Get Instant Access · $27
              <ArrowRightIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-36" data-mp="1wec8ksdibzfk" />
            </a>
          </div>
        </motion.div>}
    </AnimatePresence>;
}